<template>
  <el-button
    :loading="loading"
    :disabled="disabled"
    type="success"
    @click="print">
    <span>打印面单</span>
    <span v-if="showCount">(共{{ selection.length }}项)</span>
    <printer-select-modal ref="printer" />
  </el-button>
</template>

<script>
import PrinterSelectModal from '../page/outstock/busi/printer-select-modal.vue'
function noop() {}
export default {
  name: 'BatchExpressBtn',
  components: { PrinterSelectModal },
  props: {
    callback: {
      type: Function,
      default: noop
    },
    disabled: {
      type: Boolean,
      default: true
    },
    showCount: {
      type: Boolean,
      default: false
    },
    selection: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    print() {
      if (this.selection.length === 0) {
        this.$message.error('请至少选择一个出库单')
        return
      }
      const allIds = this.selection.map(i => i.id)
      const needPrintIds = this.selection.filter(i => i.printStatus === 0 || i.printStatus === 9).map(i => i.id)
      if (needPrintIds.length > 0) {
        this.expressprint(needPrintIds, (ids) => {
          this.callback && this.callback(allIds)
          const notNeedPrintIds = needPrintIds.filter(i => ids.indexOf(i) === -1)
          const newNeedPrintIds = allIds.filter(i => notNeedPrintIds.indexOf(i) === -1)
          if (newNeedPrintIds.length === 0) {
            this.$message.error('打印失败')
            return
          }
          this.printHtml(newNeedPrintIds)
        })
      } else {
        this.printHtml(allIds)
      }
    },
    expressprint(ids, cb) {
      this.loading = true
      this.$store.dispatch('outstock/expressprint', {
        payload: {
          printFlag: 1,
          orderIdList: ids
        },
        success: (res) => {
          this.loading = false
          cb && cb(res.data.data)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    printHtml(ids) {
      this.loading = true
      this.$store.dispatch('outstock/sendlist', {
        payload: {
          pageNum: 1,
          pageSize: 1000000,
          outOrderIds: ids
        },
        success: (res) => {
          this.loading = false
          const list = []
          const map = {}
          res.data.data.records.forEach(i => {
            const { logisticsCode: documentID, printTemplateSign: signature, vendorExpress, salesOrderCode } = i
            const templateURL = vendorExpress ? vendorExpress.templateUrl : ''
            const printingPlatform = vendorExpress ? vendorExpress.printingPlatform : ''
            if (i.combinedDeliveryNumber !== 0) {
              if (!map[i.combinedDeliveryNumber]) {
                map[i.combinedDeliveryNumber] = true
                list.push(...(i.printTemplate || []).map(printData => ({ printData, documentID, signature, templateURL, printingPlatform, salesOrderCode })))
              }
            } else {
              list.push(...(i.printTemplate || []).map(printData => ({ printData, documentID, signature, templateURL, printingPlatform, salesOrderCode })))
            }
          })
          // res.data.data.records.forEach(i => {
          //   list.push(...(i.printTemplate || []).map(printTemplate => ({ printTemplate })))
          // })
          // console.log(list)
          this.$refs.printer.fetch(list)
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
